export const PAYER_SPECIAL_PRICES_FORM_MODAL = "PAYER_SPECIAL_PRICES_FORM";
export const PAYER_SPECIAL_PRICES_ATTACHMENT_MODAL = "PAYER_SPECIAL_PRICES_ATTACHMENT";
